import { Box, Button, Grid2 } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import { useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import usercalls from "../../Axios";
import consts from "../../constant";
import Header from '../Header/Header';
const drawerWidth = 260;


const RaiseDispute = () => {

    const theme = useTheme();
    const lg = useMediaQuery(theme.breakpoints.up('lg'));

    const back = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tradeType = queryParams.get("type");
    const path = usercalls()

    const Navigate = useNavigate();
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPages] = useState(1)
    const [dispute, setDispute] = useState([]);



    const getPp2 = async () => {
        try {
            const url = `${consts?.BackendUrl}/p2p/getraisedispute`;
            const response = await path.getCallWithToken({ url });
            const result = await response.json();

            if (result?.success) {
                setDispute(result?.result)
                setTotalPages(Math.ceil(result?.result.length / limit));
            }
        } catch (error) {
            console.log("🚀 ~ getAlUser ~ error", error)
        }
    }


    useEffect(() => {
        if (localStorage.getItem("adminToken")) {
            getPp2();
        } else {
            Navigate(`/${consts?.route + '/login'}`);
        }
    }, [limit, page, tradeType]);


    return (
        <div className="UserList">
            <ToastContainer />
            <Box sx={{ display: lg ? 'flex' : 'block' }}>
                <Header />
                <Box
                    component="main"
                    sx={{ flexGrow: 1, p: 5, width: { lg: `calc(100 % - ${drawerWidth}px)` }, marginTop: '50px' }}
                >
                    <Grid2 container spacing={2}>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>

                            <div className="custom_table">

                                <TableContainer>
                                    <Table aria-label="user table">
                                        <TableHead>
                                            <TableRow>
                                                {["S.No", "Date/Time", "Price", "Amount", "Total", "Status", "Action"].map((header) => (
                                                    <TableCell key={header} align="center" sx={{ fontWeight: "bold" }}>
                                                        {header}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {dispute.length > 0 ?
                                                dispute
                                                    .slice((page - 1) * limit, page * limit)
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">{limit * (page - 1) + index + 1}</TableCell>
                                                            <TableCell align="center"> {row?.createdAt?.replace("T", " ").split(".")[0]} </TableCell>
                                                            <TableCell align="center"> {row?.p2pData?.price} </TableCell>
                                                            <TableCell align="center"> {row?.p2pData?.quantity} </TableCell>
                                                            <TableCell align="center"> {Number(row?.p2pData?.price) * Number(row?.p2pData?.quantity)} </TableCell>
                                                            <TableCell align="center"> {row?.status == "open" ? "Raise A Dispute" : row?.status} </TableCell>
                                                            <TableCell align="center"> <Button onClick={() => Navigate(`/${consts?.route}/disputedetails`,{ state: row})} sx={{ color: '#fe7701', borderColor: '#fe7701', '&:hover': { borderColor: '#d66000', backgroundColor: 'rgba(254, 119, 1, 0.1)' } }} variant='outlined'> View </Button> </TableCell>
                                                        </TableRow>
                                                    )) :
                                                <TableRow>
                                                    <TableCell colSpan={8} align="center"> No Data Found </TableCell>
                                                </TableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Pagination className='pagnation'
                                    count={totalPage}
                                    page={page}
                                    onChange={(event, value) => {
                                        setPage(value);
                                    }}
                                    variant="outlined"
                                    shape="rounded" />
                            </div>


                        </Grid2>
                    </Grid2>
                </Box>
            </Box>
        </div>
    );
};

export default RaiseDispute;



